import { capitalize } from 'lodash';
import {
  CONVERSATION_CUSTOM_COLUMN_PREFIX,
  CUSTOM_COLUMN_PREFIX,
  isConversationCustomColumn,
  isCustomAggregate,
  isCustomColumn,
  isTag,
  removeCustomAggregatePrefixFromFilters,
  TAG_PREFIX,
} from '@/models/common/filters';
import JSON5 from 'json5';

/**
 * - capitalize the first letter of a string
 * - replace underscores with spaces
 * - remove 'tag:' prefix
 * - remove 'custom:' prefix
 * - remove 'custom_aggregate:' prefix
 * - remove '_v2' suffix
 *
 * @param str
 * @param disableFilterRule
 */
export function humanizeString(str: string | undefined, disableFilterRule?: boolean) {
  if (!str) return '';

  let internalStr = str;

  if (!disableFilterRule) {
    if (isTag(internalStr)) internalStr = internalStr.replace(TAG_PREFIX, '');
    if (isCustomColumn(internalStr)) internalStr = internalStr.replace(CUSTOM_COLUMN_PREFIX, '');
    if (isConversationCustomColumn(internalStr))
      internalStr = internalStr.replace(CONVERSATION_CUSTOM_COLUMN_PREFIX, '');
    if (isCustomAggregate(internalStr)) internalStr = removeCustomAggregatePrefixFromFilters(internalStr);
  }

  return capitalize(internalStr.replace(/_v2$/i, '').replace(/_/g, ' '));
}

/**
 * Check if a string is a valid JSON string.
 * If relaxed is true, means the json string can have single quotes and comments
 * e.g.
 *
 * @example
 * {
 *  // this is a comment
 *  'key': 'value'
 *  'key2': 'value2'
 *  'key3': 'value3' // this is a comment
 *  'key4': 'value4'
 * }
 * @param str
 * @param relaxed
 */
export function isJsonString(str: string, relaxed = false): boolean {
  try {
    if (relaxed) JSON5.parse(str);
    else JSON.parse(str);
  } catch {
    return false;
  }
  return true;
}

export function stringifyJSON(str: string) {
  try {
    return JSON.stringify(JSON5.parse(str), null, 2);
  } catch {
    return str;
  }
}
